<template>
  <div class="header">
    <!-- navBar -->
    <div class="nav_box w flex3">
      <img class="logo" src="@/assets/images/common/logo.png" />
      <ul class="navs flex2">
        <li
          v-for="(item, index) in tabs"
          :key="index"
          @mouseover="addActive"
          @mouseleave="removeActive($event, index)"
          :class="[activeIndex === index ? 'active' : '']"
          @click="clickTab(index)"
        >
          <a href="#" class="active">{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <!-- swiperBox -->
    <swiper
      :options="swiperOption"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      :pagination="{ clickable: true }"
      navigation
      class="swiper-box"
    >
      <swiper-slide
        ><img src="@/assets/images/common/swiper1.jpeg" alt=""
      /></swiper-slide>
      <swiper-slide
        ><img src="@/assets/images/common/swiper2.jpeg" alt=""
      /></swiper-slide>
      <swiper-slide
        ><img src="@/assets/images/common/swiper3.jpeg" alt=""
      /></swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mouseOn: false,
      // tabs: ['Home', 'SERVICES', 'TECHNOLOGY', 'ABOUT US', 'CONTACT'],
       tabs: [
        {
          name: "Home",
          path: "/",
        },
        {
          name: "SERVICES",
          path: "/service",
        },
        {
          name: "TECHNOLOGY",
          path: "/technology",
        },
        {
          name: "ABOUT US",
          path: "/about",
        },
        {
          name: "CONTACT",
          path: "/contact",
        },
      ],
      swiperOption: {
        autoplay: true,
        loop: true,
        effect: 'slide',
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
        },
      },
    }
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  created() {
  },
  methods: {
    addActive($event) {
      $event.currentTarget.classList.add('active')
    },
    removeActive($event, index) {
      if (index === this.activeIndex) {
        return
      }
      $event.currentTarget.classList.remove('active')
    },
    onSwiper() {},
    onSlideChange() {},
    clickTab(index) {
      if (index == this.activeIndex) {
        return
      }
      this.$router.push({ path: this.tabs[index].path })
    },
  },
}
</script>
<style scoped>
.header {
  width: 100%;
  background: #fff;
}
.nav_box {
  height: 118px;
}
.logo {
  width: 357px;
  height: 118px;
}
.navs li {
  height: 48px;
  width: 115px;
  margin-right: 15px;
  display: flex;
  align-items: center;
}
.navs li a {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #555555;
}
.navs li.active {
  border-top: 1px solid #008aff;
  border-bottom: 1px solid #008aff;
}
.navs li.active a {
  background: #008aff;
  color: #fff;
}
/* 轮播图 */
.swiper-box {
  width: 100%;
  height: 620px;
}
.swiper-box >>> .swiper-slide {
  width: 100%;
  height: 100%;
}
.swiper-box >>> .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue